import type { FC } from "react"
import React, { createContext, useContext } from "react"

import type { WarehouseArea } from "@/graphql/codegen/graphql"

const WarehouseContext = createContext<WarehouseArea | null>(null)

export interface WarehouseProviderProps {
  value: WarehouseArea
  children: React.ReactNode
}

export const WarehouseProvider: FC<WarehouseProviderProps> = ({ value, children }) => (
  <WarehouseContext.Provider value={value}>{children}</WarehouseContext.Provider>
)

export const useWarehouseContext = (): WarehouseArea => {
  const context = useContext(WarehouseContext)

  if (!context) {
    throw new Error("useWarehouseContext must be used within a WarehouseProvider")
  }

  return context
}
